import React from 'react'
import { Link } from 'gatsby'
import { FlexWrapper, SummaryColumn, SummaryBox } from './components'
import { Heading, Text } from 'rebass'
import typography from '../../utils/typography'

const NotFound = () => (
  <FlexWrapper flexWrap="wrap">
    <SummaryColumn
      width={[1]}
      background={{
        x1: '',
        x2: ''
      }}
    >
      <SummaryBox
        width={['85%', null, '65%']}
        pr={[0, null, '10%']}
        mx={'auto'}
        my={[
          typography.rhythm(1),
          typography.rhythm(3.5),
          typography.rhythm(3.5)
        ]}
        pb={typography.rhythm(0.5)}
      >
        <Heading as="h2" mb={2} f={[7, null, 8]} bold color={'white'}>
          404 - Page not found
        </Heading>
        <Text
          f={[4, null, 5]}
          mb={typography.rhythm(0.5)}
          bold
          lineHeight={1.25}
          color={'rgba(255, 255, 255, 0.6)'}
        >
          The page you are looking for does not exist.
        </Text>
        <p>
          Go back to the <Link to="/">homepage</Link> to see our wide selection
          for vehicles.
        </p>
      </SummaryBox>
    </SummaryColumn>
  </FlexWrapper>
)

export default NotFound
